import styled from 'styled-components';

export const InputTextWrapper = styled.div`
  position: relative;
  width: '100%';
  display: flex;
  flex-direction: column;
`;

export const InputTextStyled = styled.input`
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '40px')};
  font-weight: ${(props) => props.fontWeight};
  border: 1px solid ${(props) => props.theme.colors.gray100};
  border-radius: ${(props) => props.theme.radii.xs};
  padding: 0 8px;
  color: ${(props) => props.theme.colors.gray450};
  font-size: 0.875rem;

  &:focus {
    outline: 1px solid #80bdff !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #f6f7f9;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.span`
  color: ${(props) =>
    props.errorColor
      ? props.theme.colors[props.errorColor]
      : props.theme.colors.red500};
  font-size: 0.75rem;
  margin-left: 8px;
`;
